import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import { TLoadable, isLoaded, isUnloaded, createLoading, isLoadErrored, TSubmittable } from "../../../../sg-core";
import { selectHavainnotState } from "../selectors";
import IObservation, { INewObservation } from "../../interfaces/IObservation";
import { createRequestFetchObservationAction } from "../actions/observationActions";


// SELECTORS
const selectObservationState = createSelector(
    selectHavainnotState,
    (workPermit) => workPermit.observation
);

export const selectCurrentObservation = createSelector(
    selectObservationState,
    (state) => state.observation
);

export const selectNewObservation = createSelector(
    selectObservationState,
    (state) => state.newObservation,
)

export const selectObservationProcessForm = createSelector(
    selectObservationState,
    (state) => state.processForm,
);

export const selectDelegationStatus = createSelector(
    selectObservationState,
    (state) => state.delegationStatus,
);


// HOOKS
export const useCurrentObservationById = (observationGuid: string | null, observationId?: number): TLoadable<IObservation> => {
    const observation = useSelector(selectCurrentObservation);
    const dispatch = useDispatch();

    useEffect(() => {
        if (isLoadErrored(observation)) {
            dispatch(createRequestFetchObservationAction(observationGuid || observationId || 0));
        }
    }, [observationId])

    if (isUnloaded(observation) || (isLoaded(observation) && (observationGuid ? observation.data.guid !== observationGuid : observation.data.id !== observationId))) {
        dispatch(createRequestFetchObservationAction(observationGuid || observationId || 0));
        return createLoading()
    }

    return observation as any;
};

export const useNewObservation = (): TSubmittable<INewObservation> | undefined => useSelector(selectNewObservation)
export const useObservationProcessForm = (): TSubmittable<{ [key: string]: any }> | undefined => useSelector(selectObservationProcessForm);
export const useDelegationStatus = (): TSubmittable<any> | undefined => useSelector(selectDelegationStatus);

